import { render, staticRenderFns } from "./ProjectMediacontactPartnerFeatureEdit.vue?vue&type=template&id=7927532d"
import script from "./ProjectMediacontactPartnerFeatureEdit.vue?vue&type=script&lang=js"
export * from "./ProjectMediacontactPartnerFeatureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports